const handleTooltip = (ref) => ref.current.classList.toggle('show');

export default handleTooltip;
